<script setup>
  import {
    onMounted,
    ref,
  } from 'vue'

  import Agent from './Agent.vue'
  import Loading from '@components/Loading.vue'
  import Pagination from '@components/Pagination.vue'
  import SearchBox from './SearchBox.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import {
    pageTop
  } from '@shared/util.js'

  const page = ref(1)
  const agents = ref(null)
  const current = ref([])

  const per = window.app.page.per

  const { title } = window.app.page

  const { vt } = useI18n('agencies.index.js')
  const { callGet } = useAjax()

  onMounted(() => {
    getAgents()
  })

  /**
   * ページ移動
   */
  const handleMovePage = () => refresh()

  /**
   * 物件情報の取得（全体）
   */
  const getAgents = async () => {
    const url = new URL(location.href)
    url.pathname = `${url.pathname.replace(/\/$/, '')}.json`
    const response = await callGet(url.toString())

    if (response.agents && response.agents.length > 0) {
      agents.value = response.agents
      refresh()
    }
    else {
      agents.value = []
    }
  }

  /**
   * 物件一覧の表示
   * 表示対象のページの物件情報をajaxで取得する
   */
  const refresh = () => {
    const target = agents.value.slice(per * (page.value - 1), per * page.value)
    pageTop(100)
    Promise.allSettled(target.map((path) => callGet(path)))
      .then((results) => {
        current.value = results.filter((result) => result.status == 'fulfilled').map((result) => result.value.agent)
      })
  }
</script>

<template>
  <h1 class="c-ttl">{{ title }}</h1>
  <SearchBox />

  <template v-if="agents">
    <div class="listing">
      <template v-if="agents.length > 0">
        <Agent v-for="(agent, index) in current" :key="`agent-${index}`" :agent="agent" />
      </template>
      <template v-else>
        <div v-html="vt('empty')"></div>
      </template>
    </div>

    <Pagination v-model="page" :per="per" :total="agents.length" @move="handleMovePage" />
  </template>
  <template v-else>
    <Loading style="margin-top: 100px;" />
  </template>
</template>

<style>
</style>
